module.exports = __webpack_public_path__ + "static/media/rub.6fecdbd7.svg";